export const DeviceType = {
  mobile: "Mobile",
  tablet: "Tablet",
  pc: "PC",
};

export const REQUEST_STATUS = {
  success: "success",
  error: "error",
  ok: "Ok",
};

export const RETRY_DELAY = 15 * 1000; //15s
